export const EFFORT_LEVEL_A = 122
export const EFFORT_LEVEL_B = 123
export const EFFORT_LEVEL_C = 124
